import React, { Component } from "react";
import {
    Heading,
    Text,
    Table,
    TableHeader,
    TableBody,
    TableRow,
    TableHeaderItem,
    TableItem
} from "spectacle";

import bootcampImg from '../images/bootcamp-time-allocation.png';
import TeaserItem from "../components/TeaserItem";
import { liquidFillGaugeDefaultSettings, loadLiquidFillGauge } from '../components/liquidFillGauge';

const prepConfig = liquidFillGaugeDefaultSettings();
prepConfig.circleThickness = 0.2;
prepConfig.circleColor = "#1D3557";
prepConfig.waveColor = "#457B9D";
prepConfig.textColor = "#F1FAEE";
prepConfig.waveTextColor = "#F1FAEE";
prepConfig.textVertPosition = 0.52;
prepConfig.waveAnimateTime = 3000;
prepConfig.waveHeight = 0.1;
prepConfig.waveAnimate = true;
prepConfig.waveCount = 2;
prepConfig.waveOffset = 0.25;
prepConfig.textSize = 0.6;
prepConfig.minValue = 20;
prepConfig.maxValue = 100
prepConfig.displayPercent = true;

//onClick={() => this.deliveryGauge.update(23)}
class TimeAllocationSlide extends Component {
    prepGauge = {};
    meetingGauge = {};
    followUpGauge = {};

    componentDidMount() {
        this.prepGauge = loadLiquidFillGauge("prepGauge", 5, prepConfig);
        this.meetingGauge = loadLiquidFillGauge("meetingGauge", 94, prepConfig);
        this.followUpGauge = loadLiquidFillGauge("followUpGauge", 1, prepConfig);
    }
    render() {
        const content = this.props.content;
        return (
            <div>
                <Heading size={6} textColor="secondary" caps bold>
                    {content.title}
                </Heading>
                <Text textSize={30} textColor="primary">
                    {content.subtitle}
                </Text>
                <Table padding={30} textColor="secondary" className="bootcamps">
                    <TableHeader>
                        <TableRow>
                            <TableHeaderItem></TableHeaderItem>
                            <TableHeaderItem></TableHeaderItem>
                            <TableHeaderItem></TableHeaderItem>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        <TableRow>
                            {content.items ? content.items.map((item, index) =>
                                <TableItem key={index} className="bootcamp">
                                    <TeaserItem item={item} />
                                </TableItem>
                            ) : null}
                        </TableRow>
                        <TableRow>
                            <TableItem>
                                <svg id="prepGauge" width="100%" height="200"></svg>
                            </TableItem>
                            <TableItem>
                                <svg id="meetingGauge" width="100%" height="200"></svg>
                            </TableItem>
                            <TableItem>
                                <svg id="followUpGauge" width="100%" height="200"></svg>
                            </TableItem>
                        </TableRow>
                    </TableBody>
                </Table>

            </div>
        );
    }
}

export default TimeAllocationSlide;


// WEBPACK FOOTER //
// ./src/slides/TimeAllocationSlide.js